<template>
<div>
  <Loader v-if="isLoading"></Loader>
  <div v-else-if="!isLoading && items.length < 1">
    {{ $t('views.excmagreements.list.noAgreements') }}
  </div>
  <div v-else>
    <table class="table table-sm table-responsive-md table-striped table-hover">
      <thead>
      <tr>
        <th style="width: 5%"></th>
        <th style="width: 10%">{{$t('views.excmagreements.list.agreementNumber')}}</th>
        <th style="width: 20%">{{$t('views.excmagreements.list.dateFrom')}}</th>
        <th style="width: 20%">{{$t('views.excmagreements.list.dateTo')}}</th>
        <th style="width: 40%">{{$t('views.excmagreements.list.company')}}</th>
        <th style="width: 5%"></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item in items" :key="item['@id']">
        <td class="text-center">
          <i v-if="getDaysDiff(item.dateTo) < 30"
             class="fa fa-circle fa-lg"
             style="color: #ffc107;"
             v-b-tooltip :title="$t('views.excmagreements.list.terminationIn') + ': ' + getDaysDiff(item.dateTo) + ' ' + $t('global.days')"></i>
          <i v-else-if="getDaysDiff(item.dateTo) < 0"
             class="fa fa-circle fa-lg"
             style="color: #dc3545;"
             v-b-tooltip :title="$t('views.excmagreements.list.terminated') + ': ' + getDaysDiff(item.dateTo) + ' ' + $t('global.daysAgo')"></i>
          <i v-else class="fa fa-circle fa-lg"
             style="color: #28a544;"
             v-b-tooltip :title="$t('views.excmagreements.list.terminationIn') + ': ' + getDaysDiff(item.dateTo) + ' ' + $t('global.days')"></i>
        </td>
        <td>
          {{ item['agreementNumber'] }}
        </td>
        <td>
          {{ item['dateFrom'] }}
        </td>
        <td>
          {{ item['dateTo'] }}
        </td>
        <td>
          {{ item['company'].firmname1 }}
        </td>
        <td>
          <router-link
            :to="{name: 'EXCMAgreementShow', params: { id: item['@id'] }}">
            <button class="float-right btn btn-link fa fa-search fa-lg" v-b-tooltip.hover :title="$t('buttons.goto')" aria-hidden="true" />
          </router-link>
        </td>
      </tr>
      </tbody>
    </table>
    <div v-if="view">
      <pagination
        :view="view"
        @getPage="getPage($event)"
      ></pagination>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Pagination from '@/components/Dashboard/Layout/Pagination'
import Loader from '@/components/Dashboard/Layout/Loader'
import addParamsToQuery from '@/utils/addParamsToQuery'
import getId from '@/utils/getIdFromLink'

export default {
  name: 'Table',
  components: {
    Pagination,
    Loader
  },

  props: ['idFirm'],

  data () {
    return {
      searchParams: {
        company: getId(this.idFirm)
      }
    }
  },

  computed: {
    ...mapGetters({
      deletedItem: 'excmagreement/del/deleted',
      error: 'excmagreement/list/error',
      items: 'excmagreement/list/items',
      isLoading: 'excmagreement/list/isLoading',
      view: 'excmagreement/list/view'
    })
  },
  watch: {
    items: function (itemsList) {
      for (let i in itemsList) {
        if (itemsList[i].dateFrom) {
          itemsList[i].dateFrom = this.$moment(itemsList[i].dateFrom).format('YYYY-MM-DD')
        }
        if (itemsList[i].dateTo) {
          itemsList[i].dateTo = this.$moment(itemsList[i].dateTo).format('YYYY-MM-DD')
        }
      }
    }
  },
  beforeDestroy () {
    this.reset()
  },
  created () {
    this.getPage(addParamsToQuery('e_x_c_m_agreements', this.searchParams))
  },
  methods: {
    getDaysDiff (date) {
      return this.$moment(date).diff(this.$moment(), 'days')
    },
    ...mapActions({
      getPage: 'excmagreement/list/default'
    }),
    ...mapMutations({
      reset: 'excmagreement/list/reset'
    })
  }
}
</script>

<style scoped>

</style>
